import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { META_DESCRIPTION } from '@/utils/constants/seo/meta';
import { getAbsolutePath } from '@/utils/router/links';
const initialTitle = '匿名コンサルホットライン | PROFFIT';
const initialDescription = META_DESCRIPTION.hotline.base();
/**
 * ホットラインの metadeta 追加用コンポーネント
 */
export const HotlineMeta = (props) => {
    const { description = initialDescription, relativePath, title = initialTitle, } = props;
    return (_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: title, property: 'og:title' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: 'website', property: 'og:type' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: getAbsolutePath(relativePath), property: 'og:url' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }));
};
